var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4527 0.750075C14.8823 0.747166 15.3082 0.829398 15.7058 0.992019C16.1034 1.15464 16.4648 1.39443 16.7692 1.69753L16.24 2.22898L16.7713 1.6996C17.0745 2.00391 17.3144 2.3653 17.4771 2.76288C17.6398 3.16046 17.7221 3.58636 17.7192 4.01593C17.7163 4.44551 17.6282 4.87025 17.4602 5.26559C17.2927 5.65949 17.0491 6.01643 16.7434 6.31592L6.77753 16.2818C6.68251 16.3768 6.5637 16.4445 6.43353 16.4779L1.68635 17.6955C1.4296 17.7613 1.15716 17.6868 0.969722 17.4994C0.782285 17.3119 0.70769 17.0395 0.773505 16.7828L1.99038 12.0356C2.02376 11.9054 2.09151 11.7865 2.18656 11.6915L12.1525 1.72557C12.4521 1.41989 12.8091 1.17636 13.2031 1.00896C13.5984 0.840972 14.0232 0.752983 14.4527 0.750075ZM15.7098 2.75941C15.546 2.59662 15.3517 2.4678 15.1379 2.38038C14.9237 2.29277 14.6943 2.24847 14.4629 2.25004C14.2315 2.25161 14.0027 2.29901 13.7897 2.38951C13.5767 2.48001 13.3837 2.61181 13.222 2.7773L13.216 2.78342L3.39242 12.6069L2.54119 15.9277L5.86203 15.0759L15.6919 5.24611C15.8574 5.08446 15.9892 4.89165 16.0797 4.67875C16.1702 4.46584 16.2176 4.23711 16.2192 4.00577C16.2208 3.77444 16.1765 3.54509 16.0888 3.33098C16.0014 3.11732 15.8726 2.92307 15.7098 2.75941Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRename);
export default __webpack_public_path__ + "static/media/icon_rename.549aab9089d7fef7b2db312467d61443.svg";
export { ForwardRef as ReactComponent };